import { useEffect } from 'react'
import * as yup from 'yup'
import { useContext, useState } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import Swal from 'sweetalert2'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import { Alert, Snackbar } from '@mui/material'
import { TextEditor, FormArea, FeildWraper, FormLineBreak, FormHeading1, SelectSearch, FeildError, FormLabel, FormRadio } from '../../../../component/form/form-layout'
import { GlobalContext } from '../../../../context/Context'

const validationSchema = yup.object().shape({
    notice_type: yup.string().required('Notice type is required'),
    subject: yup.string().required('Subject is required'),
    startdate: yup.date().required('Start date is required').nullable(),
    expirydate: yup
        .date()
        .required('End date is required')
        .nullable()
        .min(
            yup.ref('startdate'),
            'End date cannot be before start date'
        ),
    users_for: yup.array().min(1, 'Select at least one employee').required('Employee selection is required'),
    comment_enabled: yup.string().required('Please select if comments are enabled'),
    notice: yup.string().required('Notice content is required'),
});

const AddUpdateNotice = ({ Style, data, onClose = () => { }, onChange = () => { }, types = [] }) => {
    const apiCall = useApiCall();
    let { state } = useContext(GlobalContext);
    const [alertData, setAlertData] = useState({ isShow: false });

    const handleClose = () => {
        setAlertData({ isShow: false })
    }
    const onApplyError = (message) => {
        setAlertData({ isShow: true, type: "error", message: message })
    }
    const formik = useFormik({
        initialValues: {
            notice_type: data?.notice_type || "",
            subject: data?.subject || "",
            startdate: data?.startdate || "",
            expirydate: data?.expirydate || "",
            users_for: data?.users_for || "",
            comment_enabled: data?.comment_enabled || "",
            notice: data?.notice || "",
            notice_image: null,
            video_url: null,
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            // Perform API POST here
            let apiData = JSON.stringify({
                "notice_type": values?.notice_type,
                "subject": values.subject,
                "startdate": values?.startdate,
                "expirydate": values?.expirydate,
                users_for: values.users_for ? values.users_for.join(',') : "", // comma-separated string
                "comment_enabled": Number(values.comment_enabled),
                "notice": values.notice,
                "notice_image": null,
                "video_url": null,
            });
            try {
                let resp = await apiCall({ method: 'post', url: `add-notice`, data: apiData });
                Swal.fire(
                    'Submitted!',
                    resp?.message,
                    'success'
                )

                formik.resetForm();
                popupClosed();
                onChange();
            } catch (error) {
                onApplyError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
                console.warn("Error : ", error)
            }
        }
    });

    const popupClosed = () => {
        onClose();
    }
    const [deptVal, setDeptVal] = useState([]);
    const [deptUserList, setDeptUserList] = useState([]);
    const getDeptUsersList = async ({ deptId = null }) => {
        let ids = deptId ? `dept_id=${deptId.map((e) => `${e},`)}` : '';

        try {
            let res = await apiCall({ method: 'get', url: `get-employee-users?${ids}` });
            setDeptUserList(res?.active_users);
        } catch (error) {
            console.warn("Error : ", error)
        }
    }

    useEffect(() => {
        getDeptUsersList({ deptId: null });
    }, []);

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        <FormHeading1>Notice Information</FormHeading1>

                        <FeildWraper>
                            <FormLabel required>Notice Type</FormLabel>
                            <SelectSearch
                                name="notice_type"
                                placeholder='- Select Notice Type -'
                                onChange={(val) => { formik.setFieldValue("notice_type", val); }}
                                value={formik.values.notice_type}
                                options={types.map((el) => ({
                                    label: el.typename,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.notice_type && formik.errors.notice_type && (
                                <FeildError>{formik.errors.notice_type}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Subject</FormLabel>
                            <input
                                type={'text'}
                                name={'subject'}
                                onChange={formik.handleChange}
                                value={formik.values.subject}
                                placeholder='Subject'
                            />
                            {formik.touched.subject && formik.errors.subject && (
                                <FeildError>{formik.errors.subject}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Start Date</FormLabel>
                            <DatePicker
                                selected={formik.values.startdate}
                                onChange={(date) => formik.setFieldValue("startdate", date)}
                                dateFormat="dd-MMMM-yyyy"
                                placeholderText="DD/MM/YYYY"
                                className="form-control"
                            />
                            {formik.touched.startdate && formik.errors.startdate && (
                                <FeildError>{formik.errors.startdate}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>End Date</FormLabel>
                            <DatePicker
                                selected={formik.values.expirydate}
                                onChange={(date) => formik.setFieldValue("expirydate", date)}
                                dateFormat="dd-MMMM-yyyy"
                                placeholderText="DD/MM/YYYY"
                                className="form-control"
                            />
                            {formik.touched.expirydate && formik.errors.expirydate && (
                                <FeildError>{formik.errors.expirydate}</FeildError>
                            )}
                        </FeildWraper>

                        <FormLineBreak />
                        <FormHeading1>Notice Assign</FormHeading1>

                        {/* DEPR */}
                        <FeildWraper width='100%'>
                            <FormLabel>Department</FormLabel>
                            <SelectSearch
                                multiple
                                name="department"
                                placeholder='- Select Department -'
                                onChange={(val) => { getDeptUsersList({ deptId: val }); setDeptVal(val) }}
                                value={deptVal}
                                options={state?.getDropdowns?.departmentList.map((el) => ({
                                    label: el.title,
                                    value: el.id,
                                }))}
                            />
                        </FeildWraper>

                        <FeildWraper width='100%'>
                            <FormLabel required>Employee</FormLabel>
                            <SelectSearch
                                multiple
                                name="users_for"
                                placeholder='- Select Employee -'
                                onChange={(val) => { formik.setFieldValue("users_for", val); }}
                                value={formik.values.users_for}
                                options={deptUserList?.map((ele) => ({
                                    label: ele?.name,
                                    value: ele?.employee_id
                                }))}
                            />
                            {formik.touched.users_for && formik.errors.users_for && (
                                <FeildError>{formik.errors.users_for}</FeildError>
                            )}
                        </FeildWraper>

                        <FormLineBreak />
                        <FormHeading1>Notice Detail</FormHeading1>

                        <FeildWraper width="100%">
                            <FormLabel required>Comments enable</FormLabel>

                            <div className="flex gap-6 items-center">
                                <FormRadio
                                    label="Yes"
                                    name="comment_enabled"
                                    value={"1"}
                                    checked={formik.values.comment_enabled === "1"}
                                    onChange={(val) => formik.setFieldValue("comment_enabled", val)}
                                />

                                <FormRadio
                                    label="No"
                                    name="comment_enabled"
                                    value={"0"}
                                    checked={formik.values.comment_enabled === "0"}
                                    onChange={(val) => formik.setFieldValue("comment_enabled", val)}
                                />
                            </div>

                            {formik.touched.comment_enabled && formik.errors.comment_enabled && (
                                <FeildError>{formik.errors.comment_enabled}</FeildError>
                            )}
                        </FeildWraper>

                        {/* <FeildWraper width='100%'>
                            <FormLabel>Number Plate Letter</FormLabel>
                            <FileUpload
                                value={formik.values.numberPlate}
                                onChange={(file) => handleFileUpload(file, "numberPlate")}
                                loader={formik.values.numberPlateLoader}
                                label="Drag & Drop files here"
                                subLabel="or click to browse"
                            />
                            {
                                (formik.touched.numberPlate && Boolean(formik.errors.numberPlate)) ?
                                    <FeildError>{formik.touched.numberPlate && formik.errors.numberPlate}</FeildError>
                                    :
                                    null
                            }
                        </FeildWraper> */}

                        <FeildWraper width='100%'>
                            <FormLabel>Notice Area</FormLabel>

                            <TextEditor
                                value={formik.values.notice}
                                onChange={(html) => formik.setFieldValue("notice", html)}
                                placeholder="Write about yourself..."
                            />

                            {formik.touched.notice && formik.errors.notice && (
                                <FeildError>{formik.errors.notice}</FeildError>
                            )}
                        </FeildWraper>
                    </FormArea>
                </div>

                <div className={`${Style.modal_foot}`}>
                    <div className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}>Cancel</div>
                    <button type='submit' className={`${Style.dcmb__submit}`}>Submit</button>
                </div>
            </form>

            <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default AddUpdateNotice
